import { Avatar, Typography } from '@mui/material';
import { FC } from 'react';
import { useAppSelector } from '../../store/hooks';
import styles from './ProfileMenuItem.module.css';

interface ProfileMenuItemProps {
}

const getRoleStr = (val: any): string => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (typeof val === 'object' && typeof val.role === 'string') return val.role;
  return '';
};

const ProfileMenuItem: FC<ProfileMenuItemProps> = (props) => {
  const { user, selectedAccount, modulePermissions } = useAppSelector(state => state.auth);
 
  const rawRole = getRoleStr(modulePermissions?.baseRole)
    || getRoleStr((user as any)?.role)
    || getRoleStr((user as any)?.baseRole)
    || (Array.isArray(user?.roles) ? getRoleStr(user?.roles[0]) : '')
    || 'Member';

  const userRole = rawRole.charAt(0).toUpperCase() + rawRole.slice(1);

  return (
    <div className={styles.ProfileMenuItem}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Avatar
          alt={user?.name || 'Picture'}
          imgProps={{ "referrerPolicy": 'no-referrer' }}
          src={`${user?.profilePic}`}
          style={{ width: '36px', height: '36px', objectFit: 'cover' }}
        />
        
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: '14px', lineHeight: 1.2 }}>
            {user?.name}
          </Typography>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '2px' }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: '13px',
                color: '#4b5563',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '160px'
              }}
            >
              {selectedAccount?.name}
            </Typography>
            {selectedAccount?.subscription?.plan && (
              <Typography
                variant="subtitle2"
                sx={{ fontSize: '12px', color: '#6b7280', pt: '1px', marginLeft: 'auto', paddingLeft: '8px', whiteSpace: 'nowrap' }}
              >
                {selectedAccount?.subscription?.plan}
              </Typography>
            )}
          </div>

          <div style={{ marginTop: '2px' }}>
            <Typography variant="subtitle2" sx={{ color: '#059669', fontWeight: 600, fontSize: '12px', lineHeight: 1.2 }}>
              {userRole}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenuItem;
